import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { PopUpNotificationDto } from './models/popup-notification-dto.model';

export interface PopUpNotificationState extends EntityState<PopUpNotificationDto> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'popup-notifications', idKey: 'popUpNotificationId' })
export class PopUpNotificationStore extends EntityStore<PopUpNotificationState> {
  constructor() {
    super({});
  }
}
